import { CommonModule } from '@angular/common';
import { Component, Input, Optional, Self } from '@angular/core';
import { NgControl, ControlContainer, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-site-contact',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './site-contact.component.html',
  styleUrl: './site-contact.component.scss'
})
export class SiteContactComponent {
  @Input() heading: string = "Site Contact";
  @Input() siteContact: string | undefined;
  @Input() sitePhone: string | undefined;
  @Input() siteEmail: string | undefined;
  @Input() inputClass: string = 'col-md-2';

  form: any;

  constructor(
      @Optional() @Self() private controlDir: NgControl,
      private controlContainer: ControlContainer
  ) {

  }

  ngOnInit(): void {
      if (this.controlDir && this.controlDir.control) {
          this.form = this.controlDir.control.parent;
      } else if (this.controlContainer && this.controlContainer.control) {
          this.form = this.controlContainer.control;
      }

    if (this.form.get('siteEmail') !== null) {
      this.form.get('siteEmail').setValidators([Validators.email]);
    }
  }

  isEmailInvalid(): boolean {
    const emailControl = this.form?.get('siteEmail');
    return emailControl ? emailControl.invalid && (emailControl.dirty || emailControl.touched) : false;
  }
}
